import { useDynamicFavicon } from '@/hooks/useBranding';

/**
 * Provider component that updates favicon and theme meta tags 
 * dynamically based on branding settings from the database
 */
export function DynamicFaviconProvider() {
  useDynamicFavicon();
  return null;
}
